import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckmarkSvg',
  props: {
  width: {
    type: [String, Number],
    default: 9,
  },
  height: {
    type: [String, Number],
    default: 9,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    fill: "none"
  }, _ctx.$attrs, {
    width: __props.width,
    height: __props.height
  }), [
    _createElementVNode("path", {
      d: "M8.1 0L2.52 6.13635L0.9 4.90935H0L2.52 9L9 0H8.1Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})